export default __webpack_public_path__ + "static/media/lu.8f4d6985.svg";